import { useState, useRef } from 'react';

interface UseAudioUploadReturn {
  audioFile: File | null;
  audioUrl: string | null;
  isPlaying: boolean;
  audioRef: React.RefObject<HTMLAudioElement>;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleUploadClick: () => void;
  togglePlayPause: () => void;
  onEnded: () => void;
}

export const useAudioUpload = (
  onAudioUpload?: (file: File) => void,
): UseAudioUploadReturn => {
  const [audioFile, setAudioFile] = useState<File | null>(null);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setAudioFile(file);

      // Créer un URL pour le fichier audio
      const url = URL.createObjectURL(file);
      setAudioUrl(url);

      if (onAudioUpload) {
        onAudioUpload(file);
      }
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const onEnded = () => {
    setIsPlaying(false);
  };

  return {
    audioFile,
    audioUrl,
    isPlaying,
    audioRef,
    fileInputRef,
    handleFileChange,
    handleUploadClick,
    togglePlayPause,
    onEnded,
  };
};
